var _rect, _style, _title, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _text, _path9, _text2, _path0, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem44Ru(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st1{fill:#999}.st4{fill:#5f5f5f}.st9{fill:#369;fill-opacity:.502}.st10{fill:#fff}.st11{font-family:'ArialMT'}.st12{font-size:11.4815px}\n  ")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 65.668701171875,
    x2: 135.19369506835938,
    y1: 331.6766052246094,
    y2: 313.9765930175781,
    gradientTransform: "matrix(1.8664 0 0 1.8662 -39.0149 -464.7441)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6549,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 64.0613021850586,
    cy: 268.9949951171875,
    r: 16,
    gradientTransform: "matrix(1.8664 0 0 1.8662 32.3758 -435.5379)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    x1: 307.9916076660156,
    x2: 378.3916015625,
    y1: 329.52880859375,
    y2: 315.65380859375,
    gradientTransform: "matrix(1.8664 0 0 1.8662 -39.0149 -464.7441)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6549,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 64.0613021850586,
    cy: 268.9949951171875,
    r: 16.549999237060547,
    gradientTransform: "matrix(1.8664 0 0 1.8662 486.0103 -436.6576)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    x1: 186.6696014404297,
    x2: 256.8446044921875,
    y1: 330.19110107421875,
    y2: 315.19110107421875,
    gradientTransform: "matrix(1.8664 0 0 1.8662 -39.0149 -464.7441)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6549,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 64.0613021850586,
    cy: 268.9949951171875,
    r: 17.25,
    gradientTransform: "matrix(1.8664 0 0 1.8662 261.7594 -435.0714)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), /*#__PURE__*/React.createElement("path", {
    d: "M749.390243947506,-0.6097560524940493 H-0.6097560524940491 v289.4 h750 V-0.6097560524940493 z",
    style: {
      fill: "none"
    },
    id: "svg_1",
    className: "selected"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.4 78.9c-3.2-.9-7.4-1.6-12.7-2.1-5.4-.6-11.3-.8-17.9-.8-6.5 0-12.4.3-17.7.8-5.4.5-9.6 1.2-12.7 2.1-3.2.9-4.8 1.8-4.9 2.9.1 1.1 1.7 2.1 4.9 3.2 3.1 1.1 7.3 2 12.7 2.7 5.3.7 11.2 1.2 17.7 1.2 6.6-.1 12.6-.5 17.9-1.2 5.3-.7 9.5-1.6 12.7-2.7s4.8-2.1 4.9-3.2c-.1-1.1-1.7-2-4.9-2.9z",
    className: "st1",
    id: "svg_2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.5,84.29024394750596 c-3.2,1.1 -7.4,2 -12.7,2.7 c-5.4,0.7000000000000001 -11.3,1.2 -17.9,1.2 c-6.5,-0.1 -12.4,-0.5 -17.7,-1.2 c-5.4,-0.7000000000000001 -9.6,-1.6 -12.7,-2.7 c-3.2,-1.1 -4.8,-2.1 -4.9,-3.2 l-31.2,99.1 c-0.1,1.2 0.9,2.5 3,4 c2,1.5 5.5,3 10.5,4.4 c4.9,1.4 11.7,2.5 20.3,3.5 c8.6,0.9 19.5,1.3 32.7,1.4 c15.7,-0.1 28.5,-0.8 38.5,-2.1 s17.3,-2.9 22,-4.8 s7.1,-3.6 7,-5.2 l-32,-100.2 c-0.1,1 -1.7000000000000002,2.1 -4.9,3.1 z",
    style: {
      fill: "url(#SVGID_1_)"
    },
    id: "svg_3",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.2 82.8c.9-.7 1.2-1.2 1.1-1.2 0-3.5-.8-6.9-2.3-10.2s-3.9-6-7.1-8.1c-3.2-2.2-7.2-3.3-12-3.4-4.8.1-8.9 1.1-12.3 3.1s-5.9 4.6-7.7 7.9c-1.8 3.2-2.7 6.8-2.7 10.6-.1.1.2.5 1.1 1.2.8.7 2.8 1.5 6 2.2 3.2.7 8.2 1.2 14.9 1.2 6.7-.1 11.7-.5 14.8-1.2 3.3-.6 5.3-1.4 6.2-2.1z",
    style: {
      fill: "url(#SVGID_2_)"
    },
    id: "svg_4"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.5 63.5c-.1-4.7-1-8.9-2.9-12.7-1.9-3.9-4.5-6.9-7.7-9.1-3.2-2.3-6.7-3.5-10.5-3.5-3.9.1-7.4 1-10.4 2.8-3 1.9-5.4 4.4-7.2 7.7-1.7 3.2-2.6 7-2.6 11.2.1 3.4 1.1 6.7 2.8 9.7l8.6-7.5c-.6-4.4-.1-7.8 1.5-10.2s4-3.6 7.3-3.6c2.2.1 4.3 1.2 6.3 3.3 1.9 2.1 3.3 4.4 4 7.1.7 2.6.5 4.9-.7 6.8-.1.1-.2.7-.4 2.1-.1 1.2.2 2.6.9 4.1 1.1 1.6 2.1 2.7 3.2 3.2 1.1.6 2 .8 2.7.7.9-.1 1.3-.1 1.4-.2 2.5-2.7 3.7-6.6 3.7-11.9z",
    className: "st4",
    id: "svg_5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M631.7 78.9c-3.1-.9-7.3-1.6-12.7-2.1-5.3-.6-11.2-.8-17.7-.8-6.6 0-12.6.3-17.9.8-5.3.5-9.5 1.2-12.7 2.1s-4.8 1.8-4.9 2.9c.1 1.1 1.7 2.1 4.9 3.2s7.4 2 12.7 2.7c5.4.7 11.3 1.2 17.9 1.2 6.5-.1 12.4-.5 17.7-1.2 5.4-.7 9.6-1.6 12.7-2.7 3.2-1.1 4.8-2.1 4.9-3.2-.1-1.1-1.7-2-4.9-2.9z",
    className: "st1",
    id: "svg_6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M631.6 84.9c-3.1 1.1-7.3 2-12.7 2.7-5.3.7-11.2 1.2-17.7 1.2-6.6-.1-12.6-.5-17.9-1.2-5.3-.7-9.5-1.6-12.7-2.7s-4.8-2.1-4.9-3.2l-31.2 99.1c-.1 1.2.9 2.5 3 4 2 1.5 5.5 3 10.5 4.4s11.8 2.5 20.4 3.5c8.6.9 19.6 1.3 32.8 1.4 15.7-.1 28.5-.8 38.4-2.1 10-1.3 17.3-2.9 21.9-4.8 4.7-1.9 7.1-3.6 7-5.2l-32-100.2c-.1 1-1.7 2.1-4.9 3.1z",
    style: {
      fill: "url(#SVGID_3_)"
    },
    id: "svg_7",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.3 82.8c.9-.7 1.2-1.2 1.1-1.2 0-3.5-.8-6.9-2.3-10.2s-3.9-6-7-8.1c-3.2-2.2-7.2-3.3-11.9-3.4-4.9.1-9 1.1-12.4 3.1s-5.9 4.6-7.7 7.9c-1.8 3.2-2.7 6.8-2.7 10.6-.1.1.2.5 1.1 1.2.9.7 2.9 1.5 6 2.2 3.2.7 8.2 1.2 14.9 1.2 6.7-.1 11.7-.5 14.8-1.2 3.2-.6 5.2-1.4 6.1-2.1z",
    style: {
      fill: "url(#SVGID_4_)"
    },
    id: "svg_8"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M621.7 63.5c-.1-4.7-1-8.9-2.9-12.7-1.9-3.9-4.5-6.9-7.7-9.1-3.2-2.3-6.7-3.5-10.5-3.5-3.9.1-7.4 1-10.4 2.8-3 1.9-5.4 4.4-7.2 7.7-1.7 3.2-2.6 7-2.6 11.2.1 3.4 1.1 6.7 2.8 9.7L592 62c-.7-4.4-.2-7.8 1.3-10.2 1.6-2.4 4-3.6 7.3-3.6 2.2.1 4.3 1.2 6.3 3.3 1.9 2.1 3.3 4.4 4 7.1.8 2.6.6 4.9-.6 6.8-.1.1-.2.7-.5 2.1-.2 1.2.1 2.6.8 4.1 1.1 1.6 2.1 2.7 3.2 3.2 1.1.6 2 .8 2.7.7.9-.1 1.3-.1 1.4-.2 2.6-2.6 3.8-6.5 3.8-11.8z",
    className: "st4",
    id: "svg_9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M405 78.9c-3.1-.9-7.3-1.6-12.7-2.1-5.3-.6-11.2-.8-17.7-.8-6.6 0-12.6.3-17.9.8s-9.5 1.2-12.7 2.1-4.8 1.8-4.9 2.9c.1 1.1 1.7 2.1 4.9 3.2s7.4 2 12.7 2.7c5.4.7 11.3 1.2 17.9 1.2 6.5-.1 12.4-.5 17.7-1.2 5.4-.7 9.6-1.6 12.7-2.7 3.2-1.1 4.8-2.1 4.9-3.2-.1-1.1-1.7-2-4.9-2.9z",
    className: "st1",
    id: "svg_10"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M405 84.9c-3.1 1.1-7.3 2-12.7 2.7-5.3.7-11.2 1.2-17.7 1.2-6.6-.1-12.6-.5-17.9-1.2-5.4-.7-9.6-1.6-12.7-2.7-3.2-1.1-4.8-2.1-4.9-3.2L308 180.9c-.1 1.2.9 2.5 3 4 2 1.5 5.5 3 10.5 4.4s11.8 2.5 20.4 3.5c8.6.9 19.6 1.3 32.8 1.4 15.7-.1 28.5-.8 38.4-2.1 10-1.3 17.3-2.9 21.9-4.8 4.7-1.9 7.1-3.6 7-5.2L409.9 81.8c-.1 1-1.7 2.1-4.9 3.1z",
    style: {
      fill: "url(#SVGID_5_)"
    },
    id: "svg_11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.7 82.8c.9-.7 1.2-1.2 1.1-1.2 0-3.5-.8-6.9-2.3-10.2s-3.9-6-7.1-8.1c-3.2-2.2-7.2-3.3-12-3.4-4.8.1-8.9 1.1-12.2 3.1-3.4 2-5.9 4.6-7.7 7.9-1.8 3.2-2.7 6.8-2.7 10.6-.1.1.2.5 1.1 1.2.8.7 2.8 1.5 6 2.2s8.2 1.2 14.9 1.2c6.7-.1 11.7-.5 14.8-1.2 3.2-.6 5.2-1.4 6.1-2.1z",
    style: {
      fill: "url(#SVGID_6_)"
    },
    id: "svg_12"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M395.2 63.5c-.1-4.7-1-8.9-2.9-12.7-1.9-3.9-4.5-6.9-7.7-9.1-3.2-2.3-6.7-3.5-10.5-3.5-3.9.1-7.4 1-10.4 2.8-3 1.9-5.4 4.4-7.2 7.7-1.7 3.2-2.6 7-2.6 11.2.1 3.4 1 6.7 2.8 9.7l8.6-7.5c-.6-4.4-.2-7.8 1.4-10.2s4.1-3.6 7.4-3.6c2.2.1 4.3 1.2 6.3 3.3 1.9 2.1 3.3 4.4 4 7.1.7 2.6.5 4.9-.7 6.8-.1.1-.2.7-.4 2.1-.1 1.2.2 2.6.9 4.1 1.1 1.6 2.1 2.7 3.2 3.2 1.1.6 2 .8 2.7.7.9-.1 1.3-.1 1.4-.2 2.4-2.7 3.6-6.6 3.7-11.9z",
    className: "st4",
    id: "svg_13"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M167.8 53.5c-1.1-3.2-2.7-6-4.8-8.4-2-2.4-4.3-4.3-7-5.7s-5.5-2.1-8.5-2.1c-3.1 0-5.9.6-8.5 1.7-2.6 1.2-4.8 2.8-6.6 4.9-1.9 2-3.3 4.4-4.4 7.1-1.1 2.8-1.6 5.8-1.6 9 .1 3.4.9 6.5 2.5 9.3-1.5 2.2-2.5 4.6-3.1 7.2-4.1.6-7.3 1.2-9.7 2-1.3.4-2.3.9-3 1.3-.5.3-.9.6-1.1.9-.2.2-.3.6-.4.9l-31.2 99.3v.2c0 .8.3 1.6.9 2.4.9 1.5 2.7 2.9 5.4 4.1 2.7 1.3 6.7 2.6 11.9 3.7 5.1 1.2 11.7 2.1 19.8 2.8s17.9 1.1 29.4 1.1c11.8 0 22-.4 30.6-1.2s15.6-1.8 21.1-3.1 9.6-2.7 12.3-4.1c1.3-.6 2.4-1.2 3.2-2.1.8-.7 1.2-1.6 1.3-2.6l-.2-.2-31.8-100.4c-.1-.4-.2-.7-.4-.9-.6-.6-1.2-1-1.9-1.3-1.2-.6-2.8-1.2-4.8-1.6-1.9-.5-4.2-.9-6.7-1.1-.4-2.1-1.1-4-2-6 .6-2 .9-4.3.9-7 .2-3.6-.4-6.9-1.6-10.1m-6.1-7.1c1.9 2.2 3.3 4.7 4.4 7.7 1.1 3 1.6 6.2 1.6 9.5-.1 2.7-.4 5-.9 6.9l-.2.4.2.4c.9 2 1.6 4.1 2.1 6.3l.2.6.7.2c4.2.4 7.4 1.1 9.7 1.9 1.1.4 1.9.7 2.4 1.1.2.1.4.2.6.4v.2l32.1 100.3c-.1.2-.3.6-.7 1-.9 1-3 2.1-6.2 3.2-4.7 1.8-12 3.4-21.8 4.7s-22.5 2-37.9 2.1c-13.1 0-24-.5-32.6-1.4s-15.4-2-20.3-3.5c-4.9-1.4-8.2-2.7-10.1-4.1-1.1-.8-1.7-1.5-2.1-2.1-.3-.4-.5-.8-.6-1L113.6 82v-.4c.1-.2.6-.6 1.3-.9 1.1-.5 2.6-1 4.7-1.4s4.5-.8 7.3-1.2h.6l.2-.7c.6-2.8 1.6-5.3 3.2-7.7l.4-.6-.4-.4c-1.6-2.8-2.4-5.8-2.4-9 0-3 .5-5.8 1.4-8.3 1-2.5 2.3-4.6 4-6.4 1.8-1.9 3.9-3.3 6.2-4.4 2.3-1.1 4.9-1.6 7.7-1.6 2.7 0 5.3.7 7.7 2 2.2 1.4 4.4 3.2 6.2 5.4m-2.6 16.8v-1.7c0-1.6-.3-3.2-1-4.9-.6-1.7-1.5-3.2-2.5-4.5-1.2-1.5-2.4-2.7-3.7-3.5-1.4-.8-2.8-1.2-4.3-1.3-3.1-.1-5.5.9-7.3 3-1.7 1.9-2.6 4.6-2.6 8-.1 1.2 0 2.4.2 3.7l.2 1.1 1.1-.4c2.9-1.3 6.1-1.9 9.7-1.9 3.5 0 6.5.6 9 1.7l1.2.7m-19.6-4.9c0-3 .7-5.3 2.1-6.9 1.4-1.5 3.4-2.2 6-2.2 1 0 2.1.4 3.4 1.1.9.5 1.7 1.2 2.4 2.1.8.8 1.5 1.7 2.1 2.8.9 1.7 1.5 3.5 1.8 5.2-2.4-.9-5.2-1.3-8.3-1.3-3.4 0-6.5.5-9.2 1.6-.2-.8-.3-1.6-.3-2.4zM389.7 45.1c-2.1-2.4-4.4-4.3-7.1-5.7s-5.6-2.1-8.6-2.1-5.8.6-8.4 1.7c-2.6 1.2-4.9 2.8-6.7 4.9-1.9 2-3.3 4.4-4.4 7.1-1.1 2.8-1.6 5.8-1.6 9 .1 3.4.9 6.5 2.5 9.3-1.5 2.2-2.5 4.6-3.1 7.2-3.9.6-7.2 1.2-9.7 2-1.3.3-2.3.7-3 1.3-.4.3-.7.6-1.1.9-.2.2-.3.6-.4.9L307 180.8v.2c0 .8.3 1.6.9 2.4.9 1.5 2.7 2.9 5.4 4.1 2.7 1.3 6.7 2.6 11.9 3.7 5.2 1.2 11.8 2.1 19.9 2.8s17.9 1.1 29.5 1.1c11.8 0 21.9-.4 30.4-1.2 8.6-.8 15.6-1.8 21.1-3.1s9.6-2.7 12.3-4.1c1.3-.6 2.4-1.2 3.2-2.1.8-.7 1.2-1.6 1.3-2.6l-.2-.2-31.9-100.3c-.1-.4-.2-.7-.4-.9-.5-.5-1.1-1-1.9-1.5-1.2-.6-2.8-1.1-4.8-1.5-1.9-.4-4.2-.8-6.7-1-.4-2.1-1.1-4-2-6 .6-2 .9-4.3.9-7 0-3.5-.6-6.9-1.7-10.1-.9-3.2-2.5-6-4.5-8.4m-1.5 1.3c1.9 2.2 3.3 4.7 4.4 7.7s1.6 6.2 1.6 9.5c-.1 2.7-.4 5-.9 6.9l-.2.4.2.4c.9 2 1.7 4.1 2.2 6.3v.6l.7.2c4.2.4 7.4 1.1 9.7 1.9 1.1.4 1.9.7 2.4 1.1.2.1.4.2.6.4v.2L441 182.3c-.1.2-.3.6-.7 1-.9 1-3 2.1-6.2 3.2-4.7 1.8-11.9 3.4-21.7 4.7-9.8 1.3-22.4 2-37.8 2.1-13.2 0-24.1-.5-32.8-1.4-8.6-.9-15.4-2-20.3-3.5-4.9-1.4-8.2-2.7-10.1-4.1-1-.8-1.7-1.5-2.1-2.1-.3-.4-.5-.8-.6-1L340.1 82v-.4c.1-.2.6-.6 1.3-.9 1.1-.5 2.6-1 4.7-1.4s4.5-.8 7.3-1.2h.6l.2-.7c.6-2.8 1.7-5.3 3.2-7.7l.4-.6-.4-.4c-1.6-2.8-2.4-5.8-2.4-9 0-3 .5-5.8 1.5-8.3.9-2.5 2.3-4.6 4.1-6.4 1.7-1.9 3.7-3.3 6-4.4 2.3-1.1 4.9-1.6 7.7-1.6 2.7 0 5.3.7 7.7 2s4.4 3.2 6.2 5.4m-2.6 16.8v-1.7c0-1.6-.3-3.2-1-4.9-.6-1.7-1.5-3.2-2.5-4.5-1.1-1.5-2.3-2.7-3.7-3.5-1.4-.8-2.8-1.2-4.3-1.3-3.1-.1-5.5.9-7.3 3-1.7 1.9-2.6 4.6-2.6 8-.1 1.2.1 2.4.4 3.7l.2 1.1.9-.4c2.9-1.3 6.1-1.9 9.7-1.9 3.5 0 6.5.6 9 1.7l1.2.7M366 58.3c.1-3 .7-5.3 2.1-6.9 1.4-1.5 3.4-2.2 6-2.2 1.1 0 2.2.4 3.4 1.1.9.5 1.7 1.2 2.4 2.1.8.8 1.5 1.7 2.1 2.8 1.1 1.7 1.6 3.5 1.8 5.2-2.4-.9-5.1-1.3-8.3-1.3-3.4 0-6.5.5-9.2 1.6-.2-.8-.3-1.6-.3-2.4zM620.9 53.5c-1.1-3.2-2.7-6-4.7-8.4-2.1-2.4-4.4-4.3-7.2-5.7-2.7-1.4-5.5-2.1-8.5-2.1s-5.8.6-8.4 1.7c-2.6 1.2-4.9 2.8-6.7 4.9-1.9 2-3.3 4.4-4.4 7.1-1.1 2.8-1.6 5.8-1.6 9 .1 3.4.9 6.5 2.5 9.3-1.5 2.2-2.5 4.6-3.1 7.2-4 .6-7.2 1.2-9.7 2-1.2.3-2.2.7-3 1.3-.4.3-.7.6-1.1.9-.2.2-.3.6-.4.9l-31.2 99.3v.2c.1.8.4 1.6.9 2.4.9 1.5 2.7 2.9 5.4 4.1 2.7 1.3 6.7 2.6 11.9 3.7s11.8 2.1 19.9 2.8c8.1.7 17.9 1.1 29.5 1.1 11.8 0 21.9-.4 30.4-1.2 8.6-.8 15.6-1.8 21.1-3.1s9.6-2.7 12.3-4.1c1.3-.6 2.4-1.2 3.2-2.1.8-.7 1.2-1.6 1.3-2.6l-.2-.2-31.7-100.4c-.1-.4-.2-.7-.4-.9-.6-.5-1.2-1-1.9-1.5-1.2-.6-2.8-1.1-4.8-1.5-1.9-.4-4.2-.8-6.7-1-.4-2.1-1.1-4-2-6 .6-2 .9-4.3.9-7 .1-3.6-.4-6.9-1.6-10.1m-6.1-7.1c1.9 2.2 3.3 4.7 4.4 7.7 1.1 3 1.6 6.2 1.6 9.5 0 2.7-.3 5-.9 6.9l-.2.4.2.4c1 2 1.7 4.1 2.2 6.3v.6l.7.2c4.2.4 7.4 1.1 9.7 1.9 1.1.4 1.9.7 2.4 1.1.3.1.5.2.6.4v.2l32.1 100.3c-.1.2-.3.6-.7 1-.9 1-3 2.1-6.2 3.2-4.7 1.8-11.9 3.4-21.7 4.7s-22.4 2-37.8 2.1c-13.2 0-24.1-.5-32.8-1.4-8.6-.9-15.4-2-20.3-3.5-4.9-1.4-8.2-2.7-10.1-4.1-.9-.8-1.6-1.5-2.1-2.1-.3-.4-.5-.8-.6-1L566.6 82v-.4c.1-.2.6-.6 1.3-.9 1.1-.5 2.6-1 4.7-1.4 2.1-.4 4.5-.8 7.3-1.2h.6l.2-.7c.6-2.8 1.6-5.3 3.2-7.7l.4-.6-.2-.4c-1.7-2.8-2.6-5.8-2.6-9 0-3 .5-5.8 1.5-8.3.9-2.5 2.3-4.6 4.1-6.4 1.7-1.9 3.7-3.3 6-4.4 2.3-1.1 4.9-1.6 7.7-1.6 2.7 0 5.3.7 7.7 2s4.4 3.2 6.3 5.4m-2.6 16.8v-1.7c0-1.6-.3-3.2-1-4.9-.6-1.7-1.5-3.2-2.5-4.5-1.1-1.5-2.3-2.7-3.7-3.5-1.3-.8-2.7-1.2-4.3-1.3-3-.1-5.5.9-7.3 3-1.7 1.9-2.6 4.6-2.6 8-.1 1.2.1 2.4.4 3.7l.2 1.1.9-.4c2.9-1.3 6.2-1.9 9.9-1.9 3.4 0 6.3.6 8.8 1.7l1.2.7m-19.6-4.9c0-3 .7-5.3 2.1-6.9 1.4-1.5 3.4-2.2 6-2.2 1.1 0 2.2.4 3.4 1.1.9.5 1.7 1.2 2.4 2.1.8.8 1.5 1.7 2.1 2.8 1.1 1.7 1.6 3.5 1.8 5.2-2.4-.9-5.1-1.3-8.1-1.3-3.4 0-6.6.5-9.4 1.6-.3-.8-.3-1.6-.3-2.4z",
    id: "svg_14"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M153.4 214.9c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7s-1.2-6.3-3.6-8.7z",
    className: "st9",
    id: "svg_16"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st10 st11 st12",
    transform: "matrix(0.9981,0,0,1,140.917,228.5181) ",
    id: "svg_17"
  }, "\n    1\n  ")), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M386.9 214.9c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7 5.3 3.6 8.7 3.6c3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7s-1.2-6.3-3.6-8.7z",
    className: "st9",
    id: "svg_18"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st10 st11 st12",
    transform: "matrix(0.9981,0,0,1,374.417,228.5181) ",
    id: "svg_19"
  }, "\n    2\n  ")), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M611.7 214.9c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7s-1.2-6.3-3.6-8.7z",
    className: "st9",
    id: "svg_20"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "st10 st11 st12",
    transform: "matrix(0.9981,0,0,1,599.2168,228.5181) ",
    id: "svg_21"
  }, "\n    3\n  ")), /*#__PURE__*/React.createElement("foreignObject", {
    fill: "",
    strokeDashoffset: "",
    fillRule: "nonzero",
    fontSize: 30,
    fontFamily: "ArialMT",
    letterSpacing: 0,
    wordSpacing: 0,
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    id: "svg_15",
    x: 130,
    y: 105,
    width: 611,
    height: 127,
    style: {
      color: "rgb(0, 0, 0)"
    },
    className: ""
  }, /*#__PURE__*/React.createElement("p", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      border: "none",
      outline: "none",
      fontSize: "inherit",
      lineHeight: "1em",
      padding: 0,
      margin: 0
    }
  }, "5", /*#__PURE__*/React.createElement("div", {
    style: {
      border: "none",
      outline: "none",
      fontSize: "inherit",
      lineHeight: "1em",
      padding: 0,
      margin: 0
    }
  }, "\u043A\u0433"))), /*#__PURE__*/React.createElement("foreignObject", {
    fill: "",
    strokeDashoffset: "",
    fillRule: "nonzero",
    fontSize: 30,
    fontFamily: "ArialMT",
    letterSpacing: 0,
    wordSpacing: 0,
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    id: "svg_24",
    x: 354,
    y: 105,
    width: 341,
    height: 145,
    style: {
      color: "rgb(0, 0, 0)"
    },
    className: ""
  }, /*#__PURE__*/React.createElement("p", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      border: "none",
      outline: "none",
      fontSize: "inherit",
      lineHeight: "1em",
      padding: 0,
      margin: 0
    }
  }, "10", /*#__PURE__*/React.createElement("div", {
    style: {
      border: "none",
      outline: "none",
      fontSize: "inherit",
      lineHeight: "1em",
      padding: 0,
      margin: 0
    }
  }, "\u043A\u0433"))), /*#__PURE__*/React.createElement("foreignObject", {
    fill: "",
    strokeDashoffset: "",
    fillRule: "nonzero",
    fontSize: 30,
    fontFamily: "ArialMT",
    letterSpacing: 0,
    wordSpacing: 0,
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    id: "svg_27",
    x: 580,
    y: 105,
    width: 232,
    height: 134,
    style: {
      color: "rgb(0, 0, 0)"
    },
    className: ""
  }, /*#__PURE__*/React.createElement("p", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      border: "none",
      outline: "none",
      fontSize: "inherit",
      lineHeight: "1em",
      padding: 0,
      margin: 0
    }
  }, "20", /*#__PURE__*/React.createElement("div", {
    style: {
      border: "none",
      outline: "none",
      fontSize: "inherit",
      lineHeight: "1em",
      padding: 0,
      margin: 0
    }
  }, "\u043A\u0433")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem44Ru);
export default __webpack_public_path__ + "static/media/item44ru.06db42f7acac7ccd5076bc9327ee10b0.svg";
export { ForwardRef as ReactComponent };